"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Markdown = exports.MARKDOWN_STYLING = void 0;
// eslint-disable-next-line no-restricted-imports
const react_showdown_1 = __importDefault(require("react-showdown"));
const styles_1 = require("common/utils/styles");
const stitches_config_1 = require("../../../stitches.config");
exports.MARKDOWN_STYLING = {
    fontSize: 14,
    lineHeight: "20px",
    strong: {
        fontWeight: styles_1.fontWeights.bold,
    },
    gap: "8px 0",
    a: {
        color: stitches_config_1.colors.contentInfo,
    },
    p: { margin: "8px 0" },
    h1: {
        margin: "8px 0",
        fontSize: 20,
        fontWeight: styles_1.fontWeights.extraBold,
    },
    h2: {
        margin: "8px 0",
        fontSize: 18,
        fontWeight: styles_1.fontWeights.extraBold,
    },
    h3: {
        margin: "8px 0",
        fontSize: 16,
        fontWeight: styles_1.fontWeights.bold,
    },
    h4: {
        margin: "8px 0",
        fontSize: 14,
        fontWeight: styles_1.fontWeights.bold,
    },
    h5: {
        margin: "8px 0",
        fontSize: 12,
        fontWeight: styles_1.fontWeights.bold,
    },
    ul: {
        marginBlock: 8,
        paddingInlineStart: 16,
        li: {
            p: {
                margin: 0,
            },
            ul: {
                marginBlock: 0,
            },
        },
    },
    ol: {
        marginBlock: 8,
        paddingInlineStart: 16,
        li: {
            p: {
                margin: 0,
            },
            ol: {
                marginBlock: 0,
            },
        },
    },
};
exports.Markdown = (0, stitches_config_1.styled)(react_showdown_1.default, {
    ...exports.MARKDOWN_STYLING,
    variants: {
        tooltip: {
            true: {
                color: stitches_config_1.colors.contentSecondary,
                fontWeight: styles_1.fontWeights.bold,
                maxWidth: "200px",
                p: {
                    color: `${stitches_config_1.colors.contentPrimaryInverted.value} !important`,
                    margin: "0",
                },
                a: {
                    color: stitches_config_1.colors.contentInfoInverted,
                },
            },
        },
    },
});
//# sourceMappingURL=data:application/json;base64,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